module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-bank-anja.d015afc3.jpeg";